import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const commonColors = {
  primary: '#48b3fb',
  secondary: '#25416C',
  accent: '#ff8300',
  error: '#FF5252',
  problemColor: '#FF4040',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  background: '#f6f6f6',
  borderColor: '#DDDDDD',
  scrollBarBackground: '#E5E5E5',
  scrollBarThumb: '#7C7C7C',
  textColor: '#646464',
};

export default createVuetify({
  ssr: true,
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'custom',
    themes: {
      custom: {
        dark: false,
        colors: {
          ...commonColors,
        },
      },
    },
  },
});
